export default __webpack_public_path__ + "static/pipes-ede54c8488efc31e9e8d75ea9fd6ef8f.png";